// src/services/axiosInterceptor.js
import axios from "axios";
import { toast } from "react-toastify";

// Flag para evitar múltiplos redirecionamentos simultâneos
let isRedirecting = false;

const handleUnauthorized = (message = "Sessão expirada. Faça login novamente.") => {
  if (isRedirecting) return;
  
  isRedirecting = true;

  // Limpar dados do localStorage
  localStorage.removeItem("sobevenda_token");
  localStorage.removeItem("sobevenda_user_id");

  // Mostrar mensagem
  toast.error(message, {
    autoClose: 2000,
  });

  // Redirecionar para login
  setTimeout(() => {
    window.location.href = "/login";
  }, 300);
};

// Configurar interceptor GLOBAL do axios
export const setupAxiosInterceptors = () => {
  // ============================================
  // INTERCEPTOR AXIOS
  // ============================================
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Se receber 401 (Unauthorized) ou 403 (Forbidden)
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        const message =
          error.response.data?.message ||
          "Sessão expirada. Faça login novamente.";
        
        handleUnauthorized(message);
      }

      return Promise.reject(error);
    }
  );

  // ============================================
  // INTERCEPTOR FETCH (para requisições que usam fetch em vez de axios)
  // ============================================
  const originalFetch = window.fetch;
  
  window.fetch = async (...args) => {
    try {
      const response = await originalFetch(...args);
      
      // Se receber 401 ou 403, redirecionar
      if (response.status === 401 || response.status === 403) {
        // Clone a response para poder ler o body
        const clonedResponse = response.clone();
        
        try {
          const data = await clonedResponse.json();
          const message = data?.message || "Sessão expirada. Faça login novamente.";
          handleUnauthorized(message);
        } catch {
          handleUnauthorized();
        }
      }
      
      return response;
    } catch (error) {
      throw error;
    }
  };

  console.log("✅ Axios e Fetch interceptors configurados");
};